import "./index.scss"
function Product() {
  return (
    <div className="product-container">
      <div className="subtitle">产品介绍</div>
      <div className="title">PRODUCT PRESENTATION</div>

      <div className="product-info">
        <div className="info-left">
          <img className="title-img" src={require("../../assets/top-logo.png")}></img>
          <div className="product-describe">
            再查查数智系统由百昌科技集团研发，是一款以合规数据为基石，融合前沿AI技术，针对国央企、金融、类金融用户风控、决策优化、财产线索查询等关键场景，打造的集深度数据挖掘、多维风险评估、实时信息预警于一体的专业SAAS系统。
          </div>
        </div>
        <div className="info-right">
          <img className="img" src={require("../../assets/product-img.png")}></img>
        </div>
      </div>
    </div>
  )
}
export default Product